import React from 'react';
import PropTypes from 'prop-types';
import Link from './Link';
import styled from 'styled-components';
import { darken } from 'polished';

import breakpoints from '../styles/breakpoints';
import { arrowRightIcon } from '../media/icons';

const StyledShortcuts = styled.div`
  margin: 0 auto;
  margin-bottom: 50px;
  max-width: ${p => p.theme.globalWidthXSmall};
  max-width: ${p =>
    p.type === 'grid' ? p.theme.globalWidthSmall : p.theme.globalWidthXSmall};

  ${breakpoints.large`
        margin-bottom 74px;
    `};
`;

const Title = styled.h2`
  font-size: 1.5625rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  line-height: 1.6;
  margin: 0 0 23px 0;
`;

const Shortcut = styled(Link)`
  background-color: ${p => p.theme.colors.lightBg};
  background-image: url(${arrowRightIcon});
  background-position: 95% 50%;
  background-repeat: no-repeat;
  background-size: 14px 14px;
  border: none;
  color: ${p => p.theme.colors.lightFont};
  display: block;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1;
  padding: 23px 55px 23px 19px;
  text-decoration: none;
  transition: 0.5s background-position, 0.5s background-color;
  margin-bottom: 10px;

  ${breakpoints.medium`
        font-size: 1.125rem;
    `} &:hover {
    color: ${p => p.theme.colors.darkFont};
    background-color: ${p =>
      p.theme.colors.lightBg && darken(0.1, p.theme.colors.lightBg)};
    background-position: 96% 50%;
  }
`;

export default function Shortcuts({ type, title, shortcuts }) {
  const shortcutsList = shortcuts.map(({ link, title }) => (
    <Shortcut key={title} to={link}>
      {title}
    </Shortcut>
  ));

  return (
    <StyledShortcuts type={type}>
      {title && <Title>{title}</Title>}

      {shortcutsList}
    </StyledShortcuts>
  );
}

Shortcuts.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  shortcuts: PropTypes.array.isRequired
};

Shortcut.defaultProps = {
  type: 'list'
};
